import { defineStore } from "pinia";

interface ApiState {
  baseUrl: string;
  baseDataUrl: string;
  riskFinderUrl: string;
  groupsUrl: string;
}

export const useApi = defineStore("api", {
  state: (): ApiState => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL || "./api",
    baseDataUrl: process.env.VUE_APP_API_BASE_DATA_URL || "./data-api",
    riskFinderUrl:
      process.env.VUE_APP_API_RISK_FINDER_URL || "./RiskFinderAPI/api",
    groupsUrl: process.env.VUE_APP_API_GROUPS_URL || "./api/groups",
  }),
  getters: {
    base(): (_: string) => string {
      return (url) => this.baseUrl + url;
    },
    data(): (_: string) => string {
      return (url) => this.baseDataUrl + url;
    },
    risk(): (_: string) => string {
      return (url) => this.riskFinderUrl + url;
    },
    groups(): (_: string) => string {
      return (url) => this.groupsUrl + url;
    },
    getRagScore(): string {
      return this.base("/accumulations/getRAGScore");
    },
    sendLog(): string {
      return this.base("/audit/sendLog");
    },
    filterOperators(): string {
      return this.data("/data/filter-operators");
    },
    listCatalogs(): string {
      return this.data("/catalogue/listCatalogs");
    },
    getDataSets(): string {
      return this.data("/catalogue/getDataSets");
    },
    getCacheKey(): string {
      return this.base("/memorycache/get/");
    },
    getAllCacheKeys(): string {
      return this.base("/memorycache/get/getAll");
    },
    deleteKey(): string {
      return this.base("/memorycache/delete/");
    },
    initSettings(): string {
      return this.base("/organisation/initSettings");
    },
    orgSettings(): string {
      return this.base("/organisation/orgSettings");
    },
    getCustomAttributes(): string {
      return this.base("/organisation/getCustomAttributes");
    },
    getAssignedCustomAttributes(): string {
      return this.base("/organisation/getAssignedCustomAttributes");
    },
    orgSettingsForOrganisation(): string {
      return this.base("/organisation/orgSettingsForOrganisation/");
    },
    existingSettings(): string {
      return this.base("/organisation/existingSettings");
    },
    updateSettings(): string {
      return this.base("/organisation/updateOrgSettings");
    },
    deleteOrgSettings(): string {
      return this.base("/organisation/deleteOrgSettings");
    },
    createOrgSettings(): string {
      return this.base("/organisation/createOrgSettings");
    },
    getUsers(): string {
      return this.risk("/usermanagement/getusers");
    },
    getUserRoles(): string {
      return this.risk("/usermanagement/getuserroles");
    },
    saveUser(): string {
      return this.risk("/usermanagement/update");
    },
    createUser(): string {
      return this.risk("/usermanagement/create");
    },
    deleteUser(): string {
      return this.risk("/usermanagement/delete");
    },
    groupsMeta(): string {
      return this.groups("/Meta");
    },
    groupsData(): string {
      return this.groups("/Data");
    },
    groupsMetaData(): string {
      return this.groups("/MetaData");
    },
    groupsGeoJson(): string {
      return this.groups("/GeoJson");
    },
    groupsAdd(): string {
      return this.groups("/Add");
    },
    groupsDelete(): string {
      return this.groups("/Delete");
    },
    groupsGetGroupList(): string {
      return this.groups("/getGroupsList");
    },
    groupsGetNewGroupId(): string {
      return this.groups("/getNewGroupId");
    },
    getGroupNumberFromCoord(): string {
      return this.base("/policies/getGroupNumberFromCoord");
    },
    lookupHitcode(): string {
      return this.base("/policies/lookupHitcode");
    },
    getReinsuranceCapacity(): string {
      return this.base("/policies/getReinsuranceCapacity");
    },
    getContainerZonesLatLon(): string {
      return this.base("/policies/getContainerZonesLatLon");
    },
    updateDatasetRecord(): string {
      return this.data(
        "/data/perilfinder2/configuration_data/allianz/dev/" +
          "datasets/contextual/{DATASET}/update"
      );
    },
  },
});
